// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .dimono-product-component h6 {
     /* padding-top: 0!important; */
     color: #19254F !important;
     font-family: "ParagraphFonts", serif !important;
     font-weight: bold;
     margin-bottom: 8px;

 }

 @media(min-width: 992px) {
  
    .dimono-product-component .container{
        padding-top: 48px;
        padding-bottom: 48px;
        padding-left: 180px;
        padding-right: 180px;

    }
     .dimono-product-component li {
         font-size: 13px !important;
     }

     .key-benifits-h6 {
         padding-top: 132px;


     }
 }

 @media (min-width:768px) and (max-width: 991px) {
     .dimono-product-component .container {
         padding-left: 64px !important;
         padding-right: 64px !important;
     }

     .product-logo {
         width: 70px
     }

     .dimono-product-component li {
         font-size: 10px !important;
     }

     .dimono-product-component h6 {
         font-size: 10px !important;
         font-weight: medium;
         color: #19254F;
     }

     .dimono-area {
         margin-top: 0 !important;
     }

 }

 @media(max-width: 767px) {
     h6 {
         font-family: 'ParagraphFonts', serif !important;

     }
 }`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/DimonoProductComponent.css"],"names":[],"mappings":"CAAC;KACI,8BAA8B;KAC9B,yBAAyB;KACzB,+CAA+C;KAC/C,iBAAiB;KACjB,kBAAkB;;CAEtB;;CAEA;;IAEG;QACI,iBAAiB;QACjB,oBAAoB;QACpB,mBAAmB;QACnB,oBAAoB;;IAExB;KACC;SACI,0BAA0B;KAC9B;;KAEA;SACI,kBAAkB;;;KAGtB;CACJ;;CAEA;KACI;SACI,6BAA6B;SAC7B,8BAA8B;KAClC;;KAEA;SACI;KACJ;;KAEA;SACI,0BAA0B;KAC9B;;KAEA;SACI,0BAA0B;SAC1B,mBAAmB;SACnB,cAAc;KAClB;;KAEA;SACI,wBAAwB;KAC5B;;CAEJ;;CAEA;KACI;SACI,+CAA+C;;KAEnD;CACJ","sourcesContent":[" .dimono-product-component h6 {\n     /* padding-top: 0!important; */\n     color: #19254F !important;\n     font-family: \"ParagraphFonts\", serif !important;\n     font-weight: bold;\n     margin-bottom: 8px;\n\n }\n\n @media(min-width: 992px) {\n  \n    .dimono-product-component .container{\n        padding-top: 48px;\n        padding-bottom: 48px;\n        padding-left: 180px;\n        padding-right: 180px;\n\n    }\n     .dimono-product-component li {\n         font-size: 13px !important;\n     }\n\n     .key-benifits-h6 {\n         padding-top: 132px;\n\n\n     }\n }\n\n @media (min-width:768px) and (max-width: 991px) {\n     .dimono-product-component .container {\n         padding-left: 64px !important;\n         padding-right: 64px !important;\n     }\n\n     .product-logo {\n         width: 70px\n     }\n\n     .dimono-product-component li {\n         font-size: 10px !important;\n     }\n\n     .dimono-product-component h6 {\n         font-size: 10px !important;\n         font-weight: medium;\n         color: #19254F;\n     }\n\n     .dimono-area {\n         margin-top: 0 !important;\n     }\n\n }\n\n @media(max-width: 767px) {\n     h6 {\n         font-family: 'ParagraphFonts', serif !important;\n\n     }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
